/*
===============================================================================================================
                                 Copyright 2022-2025, Blue Yonder Group, Inc.
                                              All Rights Reserved

                                THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
                                            BLUE YONDER GROUP, INC.

                            The copyright notice above does not evidence any actual
                                 or intended publication of such source code.

===============================================================================================================
*/

/* eslint-disable no-console */
import apiClient from '@/utilities/api-client';
import { isEmpty } from '@/utilities/validation';
import logging from '@/utilities/telemetry';
import compileChangeObject from './compile-change-object';

const { logException } = logging;

export const updateCompanyRequest = ({
  rootOrgId, merchantId, body,
}) => apiClient.post(
  `${rootOrgId}/update-company/${merchantId || rootOrgId}`,
  body,
  {
    headers: {
      'cache-control': 'no-cache',
    },
  },
);

export default async ({
  changes: changeArray, merchantId, rootOrgId,
  productName, getConfigValue, getFeature,
  sharedData, getAdminConfigValue,
}) => {
  if (isEmpty(changeArray)) return;

  const body = {
    ...compileChangeObject(changeArray, productName, getConfigValue, getFeature, sharedData, getAdminConfigValue),
  };

  try {
    await updateCompanyRequest({
      rootOrgId, merchantId: merchantId || sharedData?.selectedMerchant, body,
    });
  } catch (e) {
    logException({ eventName: 'company_record_update_failure', exception: new Error(`Could not update the company record. Reason: ${e?.message || ''}`) });
    throw new Error(e);
  }
};
